import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundHyperstarFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1c1.61 0 3.219.146 4.713.473a10 10 0 0 1-.711.529L13.755 3.5l2.247 1.498a11.5 11.5 0 0 1 3 3l1.498 2.247 1.498-2.247a11 11 0 0 1 1.492-1.767c.33.81.51 1.73.51 2.769 0 6.052-8.922 10.602-13 14v-6.019C5.351 16.765 0 14.666 0 9c0-6 6-8 12-8M7 9.9h10V8.1H7z"
                    fill="currentColor"
                />
                <path
                    d="M20.5 0A13.3 13.3 0 0 0 24 3.5 13.3 13.3 0 0 0 20.5 7 13.3 13.3 0 0 0 17 3.5 13.3 13.3 0 0 0 20.5 0"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
BubbleRoundHyperstarFilledSize24Glyph.displayName = 'BubbleRoundHyperstarFilledSize24Glyph';
